import React, { useContext, useRef, useEffect } from 'react';
import { Appbar } from 'react-native-paper';
import {
  StyleSheet, View, Animated, Platform,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

import { useColors } from '../../contexts/theme';
import MultiSelectContext from '../../contexts/MultiSelect';
import ActionsContext from './ActionsContext';


const styles = StyleSheet.create({
  leftButtons: { flexDirection: 'row', justifyContent: 'flex-start' },
  rightButtons: { flexDirection: 'row', justifyContent: 'flex-end', flex: 1 },
  appbar: { marginTop: 0 },
  flexOne: { flex: 1 },
  wrapper: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    left: 0,
    right: 0,
    zIndex: 9999,
  },
});

const interpolations = {
  translateY: {
    inputRange: [0, 1],
    outputRange: [-56, 0],
  },
  children: {
    inputRange: [0, 1],
    outputRange: [0, 56],
  },
};

const MultiSelectActionBar = ({
  children, data,
}) => {
  const colors = useColors(),
        animate = useRef(new Animated.Value(0)),
        { rightActions, leftActions, triggerAction } = useContext(ActionsContext),
        {
          isEnabled, selectAll, deselectAll, multiSelected,
        } = useContext(MultiSelectContext);

  useEffect(() => {
    Animated.timing(animate.current, {
      toValue: isEnabled ? 1 : 0,
      useNativeDriver: true,
    }).start();
  }, [isEnabled]);

  const selectAllItems = () => selectAll(data.filter((i) => !i.isCalendarEvent).map(({ id }) => id));

  return (
    (
      <Animated.View style={styles.flexOne}>
        <Animated.View style={[styles.wrapper,
          {
            top: Platform.OS === 'web' ? window.location.href.indexOf('later') > -1 ? 142 : 72 : 0,
            transform: [{
              translateY: animate.current.interpolate(interpolations.translateY),
            }],
          },
        ]}
        >
          <Appbar style={[
            styles.appbar,
            { backgroundColor: colors.primary },
          ]}
          >
            <View style={styles.leftButtons}>
              <Appbar.Action
                icon='format-list-bulleted'
                color={colors.primaryText}
                disabled={!isEnabled}
                className='scaleOnFocus'
                onPress={selectAllItems}
              />
              <Appbar.Action
                color={colors.primaryText}
                disabled={!isEnabled}
                className='scaleOnFocus'
                icon={(props) => (
                  <Icon
                    name='format-list-checkbox'
                    size={props.size}
                    {...props}
                  />
                )}
                onPress={deselectAll}
              />
            </View>
            <View style={styles.rightButtons}>
              { rightActions.map((action) => (
                <Appbar.Action
                  key={action.iconName}
                  disabled={!isEnabled}
                  className='scaleOnFocus'
                  icon={(props) => (
                    <action.IconSet
                      color={colors.primaryText}
                      size={props.size}
                      name={action.iconName}
                    />
                  )}
                  onPress={() => triggerAction(
                    action,
                    false,
                    Object.keys(multiSelected).filter((key) => multiSelected[key]),
                  )}
                />
              )) }
              { leftActions.map((action) => (
                <Appbar.Action
                  key={action.iconName}
                  disabled={!isEnabled}
                  className='scaleOnFocus'
                  icon={(props) => (
                    <action.IconSet
                      color={colors.primaryText}
                      size={props.size}
                      name={action.iconName}
                    />
                  )}
                  onPress={() => triggerAction(
                    action,
                    true,
                    Object.keys(multiSelected).filter((key) => multiSelected[key]),
                  )}
                />
              )) }
            </View>
          </Appbar>
        </Animated.View>
        <Animated.View style={[
          styles.flexOne,
          {
            transform: [{
              translateY: animate.current.interpolate(interpolations.children),
            }],
          },
        ]}
        >
          {children}
        </Animated.View>

      </Animated.View>
    )
  );
};

export default MultiSelectActionBar;
